import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { MenuService } from "../services/menu-service.service";
import { OrderCheckService } from "../services/order-check.service";

@Injectable({
  providedIn: "root",
})
export class RouteResolver implements Resolve<boolean> {
  private orderCheckService = inject(OrderCheckService);
  private router = inject(Router);
  private menuService = inject(MenuService);

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    const friendlyUrl = route.paramMap.get("friendly-name");

    if (!friendlyUrl?.length) {
      return this.redirectToCompanyNotFound();
    }

    const cached = this.orderCheckService.getParameterization();
    const hasValidCache =
      !!cached?.IsEnabled &&
      cached.FriendlyUrl?.toLowerCase() === friendlyUrl.toLowerCase();

    // Aplica cache só para não “piscar” o tema; a API sempre é consultada no refresh.
    if (hasValidCache) {
      this.menuService.setAppParameterization(cached);
      this.orderCheckService.setParameterization(cached);
    }

    return this.menuService.getParameterization(friendlyUrl).pipe(
      switchMap((newParameterization) => {
        if (newParameterization?.IsEnabled) {
          this.orderCheckService.setParameterization(newParameterization);
          this.menuService.setAppParameterization(newParameterization);
          return of(true);
        }

        if (hasValidCache) {
          return of(true);
        }

        return this.redirectToCompanyNotFound();
      }),
      catchError((error: unknown) => {
        if (hasValidCache) {
          return of(true);
        }

        const status = (error as { status?: number })?.status;
        if (status !== 404) {
          console.error("Error fetching parameterization:", error);
        }
        return this.redirectToCompanyNotFound();
      }),
    );
  }

  private redirectToCompanyNotFound(): Observable<never> {
    this.router.navigate(["/empresa-nao-encontrada"]);
    return EMPTY;
  }
}
